(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-for-product-vw-scale"]) return;
  try {
    
  $(document).ready(function () {
    const $header = $('.shopify-section-group-header-group');
    const headerHeight = $header.height();

    const throttledScroll = throttle(() => {
      const direction = lenis.direction;
      if (direction > 0 && $(window).scrollTop() > headerHeight) {
        $header.addClass('bx--translate-y-full');
      } else {
        $header.removeClass('bx--translate-y-full');
      }
    }, 250);

    $(window).on('scroll', throttledScroll);

    // Policy dropdown functionality
    const $policyToggle = $('#policy-toggle');
    const $policyDropdown = $('#policy-dropdown');
    const $policyIconOpen = $('#policy-icon-open');
    const $policyIconClose = $('#policy-icon-close');

    if ($policyToggle.length && $policyDropdown.length && $policyIconOpen.length && $policyIconClose.length) {
      let isOpen = false;

      $policyToggle.on('click', function () {
        // Ensure header is visible before toggling dropdown
        if ($header.hasClass('bx--translate-y-full')) {
          $header.removeClass('bx--translate-y-full');
        }

        isOpen = !isOpen;
        if (isOpen) {
          // Show dropdown and switch to close icon
          $policyDropdown
            .addClass('active')
            .removeClass('bx-opacity-0 bx-invisible')
            .addClass('bx-opacity-100 bx-visible');

          // Switch icons with opacity transition
          $policyIconOpen.removeClass('bx-opacity-100').addClass('bx-opacity-0');
          $policyIconClose.removeClass('bx-opacity-0').addClass('bx-opacity-100');
        } else {
          // Hide dropdown and switch to open icon
          $policyDropdown
            .removeClass('active')
            .addClass('bx-opacity-0 bx-invisible')
            .removeClass('bx-opacity-100 bx-visible');

          // Switch icons with opacity transition
          $policyIconClose.removeClass('bx-opacity-100').addClass('bx-opacity-0');
          $policyIconOpen.removeClass('bx-opacity-0').addClass('bx-opacity-100');
        }
      });

      // Close dropdown when clicking outside
      $(document).on('click', function (event) {
        if (!$policyToggle[0].contains(event.target) && !$policyDropdown[0].contains(event.target)) {
          if (isOpen) {
            isOpen = false;
            $policyDropdown
              .removeClass('active')
              .addClass('bx-opacity-0 bx-invisible')
              .removeClass('bx-opacity-100 bx-visible');

            // Reset to open icon with opacity transition
            $policyIconClose.removeClass('bx-opacity-100').addClass('bx-opacity-0');
            $policyIconOpen.removeClass('bx-opacity-0').addClass('bx-opacity-100');
          }
        }
      });

      // Close dropdown when scrolling
      $(window).on('scroll', function () {
        if (isOpen) {
          isOpen = false;
          $policyDropdown
            .removeClass('active')
            .addClass('bx-opacity-0 bx-invisible')
            .removeClass('bx-opacity-100 bx-visible');

          // Reset to open icon with opacity transition
          $policyIconClose.removeClass('bx-opacity-100').addClass('bx-opacity-0');
          $policyIconOpen.removeClass('bx-opacity-0').addClass('bx-opacity-100');
        }
      });
    }

    // Fix account dialog position on wide screens
    function updateAccountDialogPosition() {
      const $wrapper = document.querySelector('.shopify-section__header .wrapper');
      const $account = document.querySelector('shopify-account');
      if (!$wrapper || !$account || !$account.shadowRoot) return;

      const wrapperRect = $wrapper.getBoundingClientRect();
      const dialog = $account.shadowRoot.querySelector('.dialog');
      const offset = wrapperRect.left;
      if (dialog) {
        dialog.style.setProperty('inset-inline-end', offset + 'px');
      }
    }

    // Retry until shadow root is available (it may mount asynchronously)
    const retryInterval = setInterval(() => {
      const $account = document.querySelector('shopify-account');
      if ($account && $account.shadowRoot) {
        updateAccountDialogPosition();
        clearInterval(retryInterval);
      }
    }, 200);

    $(window).on('resize', debounce(updateAccountDialogPosition, 200));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-search-vw-scale"]) return;
  try {
    
  $(document).ready(function () {
    const $header = $('.shopify-section__header');
    const headerHeight = $header.height();

    const throttledScroll = throttle(() => {
      const scrollTop = $(window).scrollTop();
      const direction = lenis.direction;

      if (direction > 0 && scrollTop > headerHeight) {
        $header.addClass('bx--translate-y-full');
      } else {
        $header.removeClass('bx--translate-y-full');
      }
    }, 250);

    const headerColorSwitch = () => {
      const scrollTop = $(window).scrollTop();
      if (scrollTop > 10) {
        $header.addClass('header-scrolled');
      } else {
        $header.removeClass('header-scrolled');
      }
    };

    $(window).on('scroll', throttledScroll);
    $(window).on('scroll', headerColorSwitch);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-vw-index-scale"]) return;
  try {
    
  $(document).ready(function () {
    const $header = $('.shopify-section__header');
    const headerHeight = $header.height();

    const throttledScroll = throttle(() => {
      const direction = lenis.direction;
      if (direction > 0 && $(window).scrollTop() > headerHeight) {
        $header.addClass('bx--translate-y-full');
      } else {
        $header.removeClass('bx--translate-y-full');
      }
    }, 250);

    $(window).on('scroll', throttledScroll);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-vw-scale"]) return;
  try {
    
  $(document).ready(function () {
    // const $header = $('.shopify-section__header');
    // const headerHeight = $header.height();

    // const throttledScroll = _.throttle(() => {
    //   const direction = lenis.direction;
    //   if (direction > 0 && $(window).scrollTop() > headerHeight) {
    //     $header.addClass('bx--translate-y-full');
    //   } else {
    //     $header.removeClass('bx--translate-y-full');
    //   }
    // }, 250);

    // $(window).on('scroll', throttledScroll);

    // Policy dropdown functionality
    const $policyToggle = $('#policy-toggle');
    const $policyDropdown = $('#policy-dropdown');
    const $policyIconOpen = $('#policy-icon-open');
    const $policyIconClose = $('#policy-icon-close');

    if ($policyToggle.length && $policyDropdown.length && $policyIconOpen.length && $policyIconClose.length) {
      let isOpen = false;

      $policyToggle.on('click', function () {
        // Ensure header is visible before toggling dropdown
        // if ($header.hasClass('bx--translate-y-full')) {
        //   $header.removeClass('bx--translate-y-full');
        // }

        isOpen = !isOpen;
        if (isOpen) {
          // Show dropdown and switch to close icon
          $policyDropdown
            .addClass('active')
            .removeClass('bx-opacity-0 bx-invisible')
            .addClass('bx-opacity-100 bx-visible');

          // Switch icons with opacity only
          $policyIconOpen.removeClass('bx-opacity-100').addClass('bx-opacity-0');
          $policyIconClose.removeClass('bx-opacity-0').addClass('bx-opacity-100');
        } else {
          // Hide dropdown and switch to open icon
          $policyDropdown
            .removeClass('active')
            .addClass('bx-opacity-0 bx-invisible')
            .removeClass('bx-opacity-100 bx-visible');

          // Switch icons with opacity only
          $policyIconClose.removeClass('bx-opacity-100').addClass('bx-opacity-0');
          $policyIconOpen.removeClass('bx-opacity-0').addClass('bx-opacity-100');
        }
      });

      // Close dropdown when clicking outside
      $(document).on('click', function (event) {
        if (!$policyToggle[0].contains(event.target) && !$policyDropdown[0].contains(event.target)) {
          if (isOpen) {
            isOpen = false;
            $policyDropdown
              .removeClass('active')
              .addClass('bx-opacity-0 bx-invisible')
              .removeClass('bx-opacity-100 bx-visible');

            // Reset to open icon with opacity only
            $policyIconClose.removeClass('bx-opacity-100').addClass('bx-opacity-0');
            $policyIconOpen.removeClass('bx-opacity-0').addClass('bx-opacity-100');
          }
        }
      });

      // Close dropdown when scrolling
      $(window).on('scroll', function () {
        if (isOpen) {
          isOpen = false;
          $policyDropdown
            .removeClass('active')
            .addClass('bx-opacity-0 bx-invisible')
            .removeClass('bx-opacity-100 bx-visible');

          // Reset to open icon with opacity only
          $policyIconClose.removeClass('bx-opacity-100').addClass('bx-opacity-0');
          $policyIconOpen.removeClass('bx-opacity-0').addClass('bx-opacity-100');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  $(document).ready(function () {
    const $header = $('.shopify-section-group-header-group');
    const headerHeight = $header.height();

    const throttledScroll = throttle(() => {
      const direction = lenis.direction;
      if (direction > 0 && $(window).scrollTop() > headerHeight) {
        $header.addClass('bx--translate-y-full');
      } else {
        $header.removeClass('bx--translate-y-full');
      }
    }, 250);

    $(window).on('scroll', throttledScroll);

    // Policy dropdown functionality
    const $policyToggle = $('#policy-toggle');
    const $policyDropdown = $('#policy-dropdown');
    const $policyIconOpen = $('#policy-icon-open');
    const $policyIconClose = $('#policy-icon-close');

    if ($policyToggle.length && $policyDropdown.length && $policyIconOpen.length && $policyIconClose.length) {
      let isOpen = false;

      $policyToggle.on('click', function () {
        // Ensure header is visible before toggling dropdown
        if ($header.hasClass('bx--translate-y-full')) {
          $header.removeClass('bx--translate-y-full');
        }

        isOpen = !isOpen;
        if (isOpen) {
          // Show dropdown and switch to close icon
          $policyDropdown
            .addClass('active')
            .removeClass('bx-opacity-0 bx-invisible')
            .addClass('bx-opacity-100 bx-visible');

          // Switch icons with opacity transition
          $policyIconOpen.removeClass('bx-opacity-100').addClass('bx-opacity-0');
          $policyIconClose.removeClass('bx-opacity-0').addClass('bx-opacity-100');
        } else {
          // Hide dropdown and switch to open icon
          $policyDropdown
            .removeClass('active')
            .addClass('bx-opacity-0 bx-invisible')
            .removeClass('bx-opacity-100 bx-visible');

          // Switch icons with opacity transition
          $policyIconClose.removeClass('bx-opacity-100').addClass('bx-opacity-0');
          $policyIconOpen.removeClass('bx-opacity-0').addClass('bx-opacity-100');
        }
      });

      // Close dropdown when clicking outside
      $(document).on('click', function (event) {
        if (!$policyToggle[0].contains(event.target) && !$policyDropdown[0].contains(event.target)) {
          if (isOpen) {
            isOpen = false;
            $policyDropdown
              .removeClass('active')
              .addClass('bx-opacity-0 bx-invisible')
              .removeClass('bx-opacity-100 bx-visible');

            // Reset to open icon with opacity transition
            $policyIconClose.removeClass('bx-opacity-100').addClass('bx-opacity-0');
            $policyIconOpen.removeClass('bx-opacity-0').addClass('bx-opacity-100');
          }
        }
      });

      // Close dropdown when scrolling
      $(window).on('scroll', function () {
        if (isOpen) {
          isOpen = false;
          $policyDropdown
            .removeClass('active')
            .addClass('bx-opacity-0 bx-invisible')
            .removeClass('bx-opacity-100 bx-visible');

          // Reset to open icon with opacity transition
          $policyIconClose.removeClass('bx-opacity-100').addClass('bx-opacity-0');
          $policyIconOpen.removeClass('bx-opacity-0').addClass('bx-opacity-100');
        }
      });
    }

    // Fix account dialog position on wide screens
    function updateAccountDialogPosition() {
      const $wrapper = document.querySelector('.shopify-section__header .wrapper');
      const $account = document.querySelector('shopify-account');
      if (!$wrapper || !$account || !$account.shadowRoot) return;

      const wrapperRect = $wrapper.getBoundingClientRect();
      const dialog = $account.shadowRoot.querySelector('.dialog');
      const offset = wrapperRect.left;
      if (dialog) {
        dialog.style.setProperty('inset-inline-end', offset + 'px');
      }
    }

    // Retry until shadow root is available (it may mount asynchronously)
    const retryInterval = setInterval(() => {
      const $account = document.querySelector('shopify-account');
      if ($account && $account.shadowRoot) {
        updateAccountDialogPosition();
        clearInterval(retryInterval);
      }
    }, 200);

    $(window).on('resize', debounce(updateAccountDialogPosition, 200));
  });

  } catch(e) { console.error(e); }
})();
})();
